import axios from 'axios';
import {RENAISSANCE_BASE_URL} from "@renaissancerentals/renaissance-component/lib/service/Api";
export const propertyId = "renaissance";
export default axios.create({
    //baseURL: "http://localhost:8080/api/"
    baseURL: RENAISSANCE_BASE_URL + "api/"
});